import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import DropdownMenu, {
  DropdownItemGroup,
  DropdownItem,
} from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';

import { DropMenuContainer } from 'src/components/settings/privileges-dropdown/privileges-dropdown.styles';

import { AccessLevel } from './constants';
import { messages } from './shared.i18n';
import { AccessLevelFilter } from './types';

export type AccessLevelDropdownProps = {
  value: AccessLevelFilter;
  onChange: (accessLevel: AccessLevelFilter) => void;
  isDisabled?: boolean;
  allowEmptyChoice?: boolean;
  isProjectContext?: boolean;
};

const AccessLevelDropdown = ({
  value,
  onChange,
  isDisabled,
  allowEmptyChoice = false,
  isProjectContext = false,
}: AccessLevelDropdownProps) => {
  const { formatMessage } = useIntl();
  let accessLevels = Object.values(AccessLevel);

  if (isProjectContext) {
    accessLevels = [AccessLevel.workspace, AccessLevel.project];
  }

  const getTriggerLabel = () => {
    if (value) {
      return formatMessage(messages[value]);
    }
    return formatMessage(messages.allAccessLevels);
  };

  return (
    <DropMenuContainer
      showValueDescription={false}
      allowEmptyChoice={allowEmptyChoice}
      fitContainer
      shiftLeft
    >
      <DropdownMenu
        testId="accessLevelDropdown"
        shouldRenderToParent
        shouldFitContainer
        spacing="compact"
        trigger={({ triggerRef, ...props }) => (
          <Button
            {...props}
            ref={triggerRef}
            iconAfter={ChevronDownIcon}
            shouldFitContainer
            isDisabled={isDisabled}
          >
            {getTriggerLabel()}
          </Button>
        )}
      >
        <DropdownItemGroup>
          {allowEmptyChoice && (
            <DropdownItem onClick={() => onChange(null)} isDisabled={!value}>
              {formatMessage(messages.allAccessLevelsMenuItem)}
            </DropdownItem>
          )}
          {accessLevels.map(accessLevel => (
            <DropdownItem
              key={accessLevel}
              isDisabled={accessLevel === value}
              onClick={() => onChange(accessLevel)}
            >
              {formatMessage(messages[accessLevel])}
            </DropdownItem>
          ))}
        </DropdownItemGroup>
      </DropdownMenu>
    </DropMenuContainer>
  );
};

// eslint-disable-next-line import/no-default-export
export default AccessLevelDropdown;
